import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { api, extractError, setAccessToken } from '@/lib/api.js';
import { BrandLogo } from '@/components/BrandLogo.js';
import { LoginBackgroundSlideshow } from '@/components/auth/LoginBackgroundSlideshow.js';
import { PasswordInput } from '@/components/ui/PasswordInput.js';

export function LoginPage() {
  const nav = useNavigate();
  const loc = useLocation();
  const sp = new URLSearchParams(loc.search);
  const next = sp.get('next') || '/inicio';

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    setLoading(true);
    try {
      const r = await api.post<{ accessToken: string }>('/auth/login', { email, password });
      setAccessToken(r.data.accessToken);
      localStorage.setItem('ha_access', r.data.accessToken);
      nav(next);
    } catch (e) {
      setErr(extractError(e).message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="relative min-h-screen">
      <LoginBackgroundSlideshow />

      <div className="relative z-10 flex min-h-screen flex-col items-center justify-center px-6">
        <div className="w-full max-w-[400px]">
          <div className="mb-10 flex flex-col items-center">
            <Link to="/" style={{ display: 'inline-block', lineHeight: 0 }}>
              <BrandLogo height={48} linkTo={null} />
            </Link>
          </div>

          <form onSubmit={handleSubmit} className="flex flex-col gap-6">
            <div className="flex flex-col gap-2">
              <label htmlFor="email" style={{ fontSize: 12, color: 'var(--text2)' }}>
                E-mail
              </label>
              <input
                id="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                className="rounded-lg border px-4 py-3 outline-none focus:ring-1"
                style={{ background: 'var(--bg2)', borderColor: 'var(--border)', color: 'var(--text)' }}
              />
            </div>

            <div className="flex flex-col gap-2">
              <div className="flex items-center justify-between gap-2">
                <label htmlFor="password" style={{ fontSize: 12, color: 'var(--text2)' }}>
                  Senha
                </label>
                <Link
                  to="/esqueci-senha"
                  className="text-[12px] underline hover:opacity-80"
                  style={{ color: 'var(--text3)' }}
                >
                  Esqueci a senha
                </Link>
              </div>
              <PasswordInput
                id="password"
                value={password}
                onChange={setPassword}
                required
                autoComplete="current-password"
              />
            </div>

            {err && (
              <p className="text-sm text-feedback">{err}</p>
            )}

            <button
              type="submit"
              disabled={loading}
              className="rounded-lg py-3 font-semibold disabled:opacity-60"
              style={{ background: 'var(--primary)', color: '#000' }}
            >
              {loading ? 'Entrando…' : 'Entrar'}
            </button>

            <p className="text-center text-[13px]" style={{ color: 'var(--text2)' }}>
              Escola de Negócios
            </p>

            <p className="text-center text-[13px]">
              <a
                href="https://conteudo.hack.net.br/ecossistema"
                target="_blank"
                rel="noopener noreferrer"
                className="underline hover:opacity-80"
                style={{ color: 'var(--text2)' }}
              >
                Conheça o Ecossistema Hack.
              </a>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
}
